import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const EVENTS_QUERY = `{
  "upcoming": *[_type == "event" && status == "upcoming"] | order(order asc) {
    title, "slug": slug.current, image, datetime, description, buttonLabel, buttonLink, buttonStyle, hasDetailPage
  },
  "past": *[_type == "event" && status == "past"] | order(order desc) {
    title, "slug": slug.current, image, datetime, description
  }
}`;

export default function Events() {
  const elementsRef = useRef([]);
  const { data: eventsData, loading } = useSanityQuery(EVENTS_QUERY);

  const upcomingList = eventsData?.upcoming || [];
  const pastList = eventsData?.past || [];

  useEffect(() => {
    const elements = elementsRef.current.filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((element) => {
      element.classList.add('hidden');
      observer.observe(element);
    });

    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, [upcomingList, pastList]);

  const getEventImageSrc = (event) => {
    if (event.image?.asset) return urlFor(event.image).width(600).url();
    return null;
  };

  const getEventLink = (event) => {
    if (event.hasDetailPage && event.slug) return `/events/${event.slug}`;
    return event.buttonLink || '/events';
  };

  return (
    <div className='wrapperItem'>
      <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/event.jpg'})`}}>
        <div className='mainbreadcumb'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>Events</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/">Home</Link>
                  <span className='dash'>/</span>
                  <span>Events</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid' id="events" style={{paddingBottom: '0px'}}>
        {!loading && (
          <div className='row m-10-hor'>
            <div className='col-md-8' id="newevents">
              <h3>Current Events</h3>
              <ul className='recent-post'>
                {upcomingList.map((event, index) => (
                  <li key={`upcoming-${index}`} ref={(el) => (elementsRef.current[2 + index] = el)}>
                    <Link className='recent' to={getEventLink(event)}>
                      {getEventImageSrc(event) && (
                        <div className='img'>
                          <img src={getEventImageSrc(event)} alt="Event" />
                        </div>
                      )}
                      <div className='contblog'>
                        <div className='title' style={{fontSize: '25px'}}>{event.title}</div>
                        <div className='datetime'>{event.datetime}</div>
                        <div className='descblog'>
                          {event.description}
                          <div style={{width: '100%', height: '1px', backgroundColor: '#ffffff', margin: '30px 0px'}}></div>
                          {event.buttonLabel && (
                            <button className='buttonEvent' style={event.buttonStyle || {}}>
                              <span>{event.buttonLabel}</span><i></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className='col-md-4'>
              <h3 style={{opacity: '0.5'}}>Passed Events</h3>
              <ul className='recent-post'>
                {pastList.map((event, index) => (
                  <React.Fragment key={`passed-${index}`}>
                    {getEventImageSrc(event) && (
                      <div className='img' style={{width: '100%', height: '200px', overflow: 'hidden', padding: '10px'}}
                        ref={(el) => (elementsRef.current[2 + upcomingList.length + index] = el)}>
                        <img src={getEventImageSrc(event)} alt="Event" />
                      </div>
                    )}
                    <li ref={(el) => (elementsRef.current[2 + upcomingList.length + pastList.length + index] = el)}>
                      <div className='contblog'>
                        <div className='title' style={{fontSize: '20px'}}>{event.title}</div>
                        <div className='datetime'>{event.datetime}</div>
                        <div className='descblog'>{event.description}</div>
                      </div>
                    </li>
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
